import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-equipement-create',
  templateUrl: './equipement-create.component.html',
  styleUrls: ['./equipement-create.component.scss']
})
export class EquipementCreateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
